import { render, staticRenderFns } from "./LocationsList.vue?vue&type=template&id=ed65bb0a&scoped=true&lang=pug&"
import script from "./LocationsList.vue?vue&type=script&lang=js&"
export * from "./LocationsList.vue?vue&type=script&lang=js&"
import style0 from "./LocationsList.vue?vue&type=style&index=0&id=ed65bb0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed65bb0a",
  null
  
)

export default component.exports